import { render, staticRenderFns } from "./EditActionBar.vue?vue&type=template&id=496f5bd2&scoped=true&"
import script from "./EditActionBar.vue?vue&type=script&lang=js&"
export * from "./EditActionBar.vue?vue&type=script&lang=js&"
import style0 from "./EditActionBar.vue?vue&type=style&index=0&id=496f5bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f5bd2",
  null
  
)

export default component.exports